import { createHttp } from './http.js'
import { createAuthApi } from './auth.js'
import { createCategoriesApi } from './categories.js'
import { createGoalsApi } from './goals.js'
import { createMilestonesApi } from './milestones.js'
import { createTasksApi } from './tasks.js'
import { createTaskItemsApi } from './taskItems.js'

// The store is imported lazily inside the callbacks: importing it at module scope would
// create a cycle (store → api → store) that leaves one of them undefined at load time.
const http = createHttp({
  async onUnauthorized() {
    const { useAuthStore } = await import('@/stores/auth.js')
    useAuthStore().handleUnauthorized()
  },
})

export const api = {
  http,
  auth: createAuthApi(http),
  goals: createGoalsApi(http),
  categories: createCategoriesApi(http),
  milestones: createMilestonesApi(http),
  tasks: createTasksApi(http),
  taskItems: createTaskItemsApi(http),
}
